export default {
    name: 'trackSendReportAdClick',
    dependencies: ['$element', 'trackingservice'],
    callable(el, trackingService) {
        const alerttypes = el.querySelector('#alertTypes');
        const submitButton = el.querySelector('#submit-reportad');
        submitButton.addEventListener('click', () => {
            trackingService.trackEventObject({
                analyticsName: 'review.report-ad.send',
                eventFlags: 'success',
                stringValue: selected(alerttypes),
            });

            function selected(alerts) {
                if (alerts.querySelector('#fraudulent').checked) {
                    return 'fraudulent';
                } else if (alerts.querySelector('#breakrules').checked) {
                    return 'breakrules';
                } else if (alerts.querySelector('#orgasprivate').checked) {
                    return 'orgasprivate';
                } else if (alerts.querySelector('#violation').checked) {
                    return 'violation';
                }
                return 'unknown';
            }
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/trackSendReportAdClick.js